module.exports = __webpack_public_path__ + "static/img/IM.ac3fe7a6.svg";